export const arrayToEnum = (arr: (string | number)[]) => `|${arr.join('|')}`;
